import { useContext, useMemo } from 'react'
import { string, oneOfType, number, func } from 'prop-types'
import { CvsCarousel } from '@components'
import { integrationContext } from '@contexts'

export const IntegrationPicker = ({
  existingIntegrations,
  type = 'output',
  selected = '',
  onSelect = () => {},
}) => {
  const { inboundById, outboundById } = useContext(integrationContext)

  const existingIntegrationsBySlug = ['facebook-ads-manager']
  if (existingIntegrations) existingIntegrations.map(i => existingIntegrationsBySlug.push(i.slug))

  const items = useMemo(() => {
    const list = Object.values(type === 'input' ? inboundById : outboundById) || []
    return list.length
      ? list.filter(i => i.slug !== 'facebook-ads-manager')
      : [{ loading: true, id: 1 }] // filter out 7 because it is the nike box integration
  }, [type, inboundById, outboundById])

  return (
    <CvsCarousel
      selectedItem={selected}
      onItemSelect={onSelect}
      items={items}
      existingIntegrations={existingIntegrationsBySlug}
    />
  )
}

IntegrationPicker.propTypes = {
  type: string,
  selected: oneOfType([string, number]),
  onSelect: func,
}
